const white = '#fff';
const grey = '#C4C4C4';
const black = '#000';

const info = '#1077E5';
const warning = '#FFB800';
const danger = '#e73e11';
const error = danger;
const success = '#6ECB7D';

const facebook = '#3B5998';
const linkedIn = '#005B90';
const google = '#2196F3';

export const colors = {
	transparent: 'transparent',
	white: white,
	black: black,
	current: 'currentColor',

	primary: {
		light: `var(--color-primary-light)`,
		DEFAULT: `var(--color-primary)`
	},

	secondary: {
		light: `var(--color-secondary-light)`,
		DEFAULT: `var(--color-secondary)`
	},
	text: {
		light: `var(--color-text-light)`,
		DEFAULT: `var(--color-text)`
	},

	grey: {
		lighter: '#F7F7F7',
		light: '#E6E6E6',
		DEFAULT: grey,
		dark: '#9597A4',
		darker: 'hsl(0, 1%, 30%)'
	},

	success: {
		light: 'hsl(130, 47%, 90%)',
		DEFAULT: success
	},

	warning: {
		light: 'hsl(43, 100%, 90%)',
		DEFAULT: warning
	},

	info: {
		light: 'hsl(211, 87%, 90%)',
		DEFAULT: info
	},

	error: {
		light: 'hsl(13, 86%, 90%)',
		DEFAULT: error
	},

	danger: {
		light: 'hsl(13, 86%, 90%)',
		DEFAULT: danger
	},

	charts: {
		warning,
		success,
		info,
		danger
	},

	facebook: facebook,
	'linked-in': linkedIn,
	google: google
};
